@if (!minimized) {
  <div class="panel">
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3">
        <div
          class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {{ virtualFolder() | titleByEventsFilter: containerName(): true }}
          @if (isAdvancedSearchApplied()) {
            – Search Results
          }
        </div>
        <div class="grow"></div>
        <!-- [MUST-003] 'Debug' button hidden per task; uncomment to re-enable
        <div
          class="debug"
          [class.active]="debug"
          (click)="doDebug()"
          >
          {{ debug || 'Debug' }}
        </div>
        -->
        @if (selectedTab === 'events' && !invitesFolder()) {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appEventsListContextMenu
            [appEventsListContextMenuWithAdvancedSearch]="true"
          />
        }
        @if (selectedTab === 'calendars') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appCalendarsListContextMenu
            [appCalendarsListContextMenuWithAdvancedSearch]="true"
          />
        }
      </div>
      @if (listState === 'tabs') {
        <app-tabs
          class="panel-heading-tabs"
          [values]="tabs"
          [value]="selectedTab"
          (valueChange)="handleSelectedTabChange($event)"
        />
      }
    </div>
    <div class="h-full flex-1 flex flex-col">
      @if (invitesFolder() && messagesFilters() && invitationTenantItems()) {
        <ng-container *appMailAppContext>
          <app-messages2-list
            [filters]="messagesFilters()"
            [tenantItems]="invitationTenantItems()"
            [notFoundTemplate]="invitesEmpty"
            (loadInProgress)="loading = $event"
            (openMessage)="handleClickMessage($event)"
            (clickMessage)="handleClickMessage($event)"
            (doubleClickMessage)="handleDoubleClickMessage($event)"
          />
        </ng-container>
        <!-- Each invites folder says what it holds (Johanna, 2026-10-21); it showed Mail's "No messages". -->
        <ng-template #invitesEmpty>
          <div class="grow basis-0"></div>
          <app-no-content-stub imageSrc="assets/placeholders/placeholder-schedule.svg" [centered]="false">
            <div class="flex max-w-full flex-col items-center gap-2">
              @if (invitesFolder() === 'received') {
                <p class="text-base font-medium text-gray-900 text-center">No event invites</p>
              } @else {
                <p class="text-base font-medium text-gray-900 text-center">No sent invites</p>
                <p class="text-sm text-gray-600 text-center">Create a new event to get started.</p>
              }
            </div>
          </app-no-content-stub>
        </ng-template>
      } @else if (selectedTab === 'events' && eventsFilters()) {
        @if (eventsListMode() === ListMode.LIST) {
          <app-events-list
            [filters]="eventsFilters()"
            [debug]="debug"
            [showLocationBadge]="isAdvancedSearchApplied()"
            (loadInProgress)="loading = $event"
            (clickEvent)="handleClickEvent($event)"
            (doubleClickEvent)="handleDoubleClickEvent($event)"
          />
        } @else {
          @if (!isAdvancedSearchApplied()) {
            <stch-sticky-events-list
              class="max-h-[287px] overflow-y-auto"
              [filters]="eventsFilters()"
              [selectionChain]="selectionChain"
              (clickEvent)="handleClickEvent($event)"
              (doubleClickEvent)="handleDoubleClickEvent($event)"
            />
          }

          <app-time-range-events-list
            [filters]="eventsFilters()"
            [selectionChain]="selectionChain"
            [debug]="debug"
            (loadInProgress)="loading = $event"
            (clickEvent)="handleClickEvent($event)"
            (doubleClickEvent)="handleDoubleClickEvent($event)"
          />
        }
      } @else if (selectedTab === 'calendars' && calendarsFilters) {
        <app-calendars-list
          [filters]="calendarsFilters"
          [debug]="debug"
          (loadInProgress)="loading = $event"
          (openCalendar)="handleClickCalendar($event)"
          (clickCalendar)="handleClickCalendar($event)"
          (doubleClickCalendar)="handleDoubleClickCalendar($event)"
        />
      }
    </div>
  </div>
}
